import axios from 'axios';

import { setNotification } from './Notification';

export const SEND_CONTACT_START = 'SEND_CONTACT_START';

export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS';

export const SEND_CONTACT_ERROR = 'SEND_CONTACT_ERROR';

export const SEND_CONTACT_RESET = 'SEND_CONTACT_RESET';

export function createSendContactStartAction() {
  return {
    type: SEND_CONTACT_START
  };
}

export function createSendContactErrorAction(error) {
  return {
    type: SEND_CONTACT_ERROR,
    payload: {
      error: error
    }
  };
}

export function createSendContactSuccessAction() {
  return {
    type: SEND_CONTACT_SUCCESS
  };
}

export function createSendContactResetAction() {
  return {
    type: SEND_CONTACT_RESET
  };
}

export function sendContact(data) {
  return dispatch => {
    dispatch(createSendContactStartAction());
    return axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/contact', data)
      .then(response => {
        if (response.status !== 201) {
          dispatch(createSendContactErrorAction(response.error));
          return;
        }
        dispatch(createSendContactSuccessAction());

        // Notification message
        dispatch(
          setNotification({
            notificationType: 'success',
            message:
              'Vielen Dank für Ihre Nachricht. Wir werden so schnell wie möglich antworten.'
          })
        );
      })
      .catch(error => {
        dispatch(createSendContactErrorAction('CONNECTION_ERROR'));

        // Notification message
        dispatch(
          setNotification({
            notificationType: 'error',
            message: 'Ooooops! Der Server antwortet nicht.'
          })
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/Contact.js